export function getQueryVariable(variable){
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i=0;i<vars.length;i++) {
    let pair = vars[i].split("=");
    if(pair[0] == variable) return pair[1];
  }
   return(false);
}

export function getQueryVariablesList(){
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  const arrayVars = [];
  for (let i=0;i<vars.length;i++) {
    let pair = vars[i].split("=");
    arrayVars.push({
      key: pair[0],
      value: pair[1]
    })
  }
  return(arrayVars);
}